export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getActions: state => state.actions,
    getDataTableOptions: state => state.dataTableOptions,
}
